import React from 'react';

import Hero from './sections/Hero/Hero';
import Founders from './sections/Founders/Founders';
import HowItWorks from './sections/HowItWorks/HowItWorks';
import Disciplines from './sections/Disciplines/Disciplines';
import Requirements from './sections/Requirements/Requirements';
import Faq from './sections/Faq/Faq';
import Join from './sections/Join/Join';

/**
 * Coded body for the Console page whose content block id is for-providers.
 * The hosted page still supplies the route, title, and app shell.
 */
const ForProvidersPage = () => (
  <>
    <Hero />
    <HowItWorks />
    <Founders />
    <Disciplines />
    <Requirements />
    <Faq />
    <Join />
  </>
);

export default ForProvidersPage;
